export const IconToSendEnvelope: {
  name: 'icon_to_send_envelope-00114a19ab3e'
} = {
  name: 'icon_to_send_envelope-00114a19ab3e'
}
